export default __webpack_public_path__ + "static/media/bg_header_mb.220ec9c2.png";